import React from "react";
import { Box, CircularProgress, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const StatusCommentHistoryModal = ({ open, onClose, title, comments, loading, error }) => {
  const { t, i18n } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="status-comment-history-title">
      <Box className="status-comment-history-modal" onClick={(e) => e.stopPropagation()}>
        <IconButton className="status-comment-history-close" onClick={onClose} aria-label={t("status_comment.close")}>
          <CloseIcon />
        </IconButton>

        <div className="status-comment-history-heading">
          <HistoryIcon />
          <h2 id="status-comment-history-title">{t("status_comment.history")}</h2>
        </div>
        <p className="status-comment-history-entity">{title}</p>

        {loading && <CircularProgress className="status-comment-history-loader" size={32} />}
        {!loading && error && <p className="status-comment-history-error">{error}</p>}
        {!loading && !error && comments.length === 0 && (
          <p className="status-comment-history-empty">{t("status_comment.history_empty")}</p>
        )}
        {!loading && !error && comments.length > 0 && (
          <div className="status-comment-history-list">
            {comments.map((item) => (
              <article className="status-comment-history-item" key={item.id}>
                <div className="status-comment-history-meta">
                  <strong>{item.author_name}</strong>
                  <time dateTime={item.created_at}>
                    {dayjs(item.created_at).locale(i18n.language).format("DD.MM.YYYY HH:mm")}
                  </time>
                </div>
                <p>{item.comment}</p>
              </article>
            ))}
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default StatusCommentHistoryModal;
